/** Display copy for a gym hero established-year kicker. */
export function gymEstablishedKicker(year?: number | null, fallback = new Date().getFullYear()) {
  const value =
    typeof year === 'number' && Number.isInteger(year) && year >= 1950 && year <= 2100
      ? year
      : fallback;
  return `ESTABLISHED ${value}`;
}

export function parseGymEstablishedYear(raw: string): number | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  if (!/^\d{4}$/.test(trimmed)) throw new Error('Use a four-digit year.');
  const year = Number(trimmed);
  if (year < 1950 || year > 2100) throw new Error('Choose a year between 1950 and 2100.');
  return year;
}
